import { useQuery } from "@tanstack/react-query";
import apiClient from "./apiClient";
import Cookies from "js-cookie";
// Fetch products from API
const fetchProducts = async () => {
  const SAVED_LANG = localStorage.getItem("lang") || "en"; // Fetch saved language

  const { data } = await apiClient.get(
    `/products?state=${Cookies.get("userData")?.state === "Test" ? "Test" : "Available"}`,
    {
      headers: { "Accept-Language": SAVED_LANG },
    }
  );

  if (data.status !== "success" || !Array.isArray(data.data)) {
    throw new Error("Invalid response format");
  }

  return data.data.map((product) => {
    // Ensure `category` and `name` are not null or undefined
    const categoryName =
      product.category?.name?.[SAVED_LANG] ||
      product.category?.name?.ar ||
      product.category?.name?.en ||
      "No Category";

    return {
      id: product._id,
      proImg: product.image,
      title:
        product.name?.[SAVED_LANG] ||
        product.name?.ar ||
        product.name?.en ||
        "No Title",
      slug: product.slug || product._id,
      price: product.price,
      delPrice: product.discountPrice,
      brand: categoryName, // Use the safe category name
      size:
        product.description?.[SAVED_LANG] ||
        product.description?.ar ||
        product.description?.en ||
        "No Description",
      maxQuantity: product.quantity,
      quantity: 0,
      description:
        product.description?.[SAVED_LANG] ||
        product.description?.ar ||
        product.description?.en ||
        "No Description",
      category: {
        _id: product.category?._id || "no-category-id",
        name: categoryName,
      },
    };
  });
};

// Hook to use products
export const useProducts = () => {
  return useQuery({ queryKey: ["products"], queryFn: fetchProducts });
};
